// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2mBQo","colMin":"styles_colMin__2jTp_","colCheckbox":"styles_colCheckbox__G9dil"};